/**
 * Created by mykurisu on 2017/8/14.
 */
import React from 'react'

class MainItemTitle extends React.Component {

    render() {
        return (
            <div className="mainpage-item-title">
                {this.props.content}
            </div>
        )
    }
}

export default MainItemTitle


// WEBPACK FOOTER //
// ./src/components/liveroomLecturer/MainItemTitle.js